import { render, staticRenderFns } from "./allGradesComparison_week.vue?vue&type=template&id=587f47dc&scoped=true&"
import script from "./allGradesComparison_week.vue?vue&type=script&lang=js&"
export * from "./allGradesComparison_week.vue?vue&type=script&lang=js&"
import style0 from "./allGradesComparison_week.vue?vue&type=style&index=0&id=587f47dc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587f47dc",
  null
  
)

export default component.exports